export const PeakMark = ({ className = "h-9 w-auto", label }) => (
  <img
    src="/assets/peak-mark.png"
    alt={label || ""}
    aria-hidden={label ? undefined : true}
    className={className}
    draggable="false"
  />
);

export const Logo = ({ dark = false }) => (
  <span className="inline-flex items-center gap-2.5">
    <PeakMark className="h-8 w-auto" label="Build.Make.Win peak mark" />
    <span
      className={`font-display text-lg font-semibold tracking-tight ${
        dark ? "text-cream" : "text-ink"
      }`}
    >
      Build.Make.Win
    </span>
  </span>
);
